import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { endpoint } from "../../../utils/constants/endpoint";

export const adminAuth = createApi({
  reducerPath: "adminAuth",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (data) => ({
        url: endpoint.ADMIN_ACCOUNT.GUEST_LOGIN,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        responseHandler: (response) => response.text(),
        body: data,
      }),
    }),
    userLogin: builder.mutation({
      query: (data) => ({
        url: endpoint.USERS.GUEST_LOGIN,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        responseHandler: (response) => response.text(),
        body: data,
      }),
    }),
  }),
});

export const { useLoginMutation, useUserLoginMutation } = adminAuth;
